/** Configuração por rota de listagem de tickets */
export const TICKET_VIEW_ROUTES = {
  '/all-tickets': {
    viewKey: 'all-tickets',
    title: 'Todos os tickets',
    demandTypePreset: [],
    defaultStatus: [],
  },
  '/tickets/support': {
    viewKey: 'tickets/support',
    title: 'Suporte / Bugs',
    demandTypePreset: ['SUPPORT'],
    defaultStatus: [],
  },
  '/tickets/improvement': {
    viewKey: 'tickets/improvement',
    title: 'Melhorias',
    demandTypePreset: ['IMPROVEMENT'],
    defaultStatus: [],
  },
  '/tickets/project': {
    viewKey: 'tickets/project',
    title: 'Projeto',
    demandTypePreset: ['PROJECT'],
    defaultStatus: [],
  },
  '/tickets/other': {
    viewKey: 'tickets/other',
    title: 'Outras demandas',
    demandTypePreset: ['OTHER'],
    defaultStatus: [],
  },
};

export const getTicketViewConfig = (pathname) =>
  TICKET_VIEW_ROUTES[pathname] || TICKET_VIEW_ROUTES['/all-tickets'];
